<div class="spb-holder">
  <spb-header></spb-header>
  <router-outlet></router-outlet>
  <div class="filler"></div>
  <spb-footer
    [license]="true"
    [token]="configService.accessToken()"
    [version]="version"
    (logoutUser)="configService.reset()"
    copyrightYears="2021"/>
</div>

